import {
  STATUS_BADGE_CONFIG,
  appointmentStatusLabel,
} from './appointmentConsultationUtils';

type AppointmentStatusBadgeProps = {
  status: string;
  className?: string;
  showIcon?: boolean;
};

/** Shared appointment status pill (icon + French label). */
export function AppointmentStatusBadge({
  status,
  className = '',
  showIcon = true,
}: AppointmentStatusBadgeProps) {
  const cfg = STATUS_BADGE_CONFIG[status];
  const Icon = cfg?.icon;

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
        cfg ? `${cfg.bg} ${cfg.text}` : 'bg-gray-100 text-gray-700'
      } ${className}`.trim()}
    >
      {showIcon && Icon ? <Icon className="w-3 h-3 mr-1 flex-shrink-0" /> : null}
      {appointmentStatusLabel(status)}
    </span>
  );
}
